<template>
    <PageLoading :loading="loading">
        <!-- 错误页面 -->
        <ErrorPage v-if="hasError" :title="errorTitle" :message="errorMessage"/>

        <!-- 正常页面 -->
        <div v-else class="home">
            <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#007AFF" lazy-render>
                <van-swipe-item v-for="(img, idx) in images" :key="idx">
                    <van-image :src="img" class="banner-img" fit="contain" />
                </van-swipe-item>
            </van-swipe>
            <div class="order-btn-wrap">
                <van-button type="primary" block round @click="goOrder">立即订购</van-button>
            </div>
        </div>
    </PageLoading>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { setWxTitle } from '@/utils/wx'
import { post } from '@/utils/request'
import { WECHAT_APPID } from '../../../config/env'

// 加载状态
const loading = ref(true)

// 错误状态
const hasError = ref(false)
const errorTitle = ref('')
const errorMessage = ref('')

const images = ref([])

// 处理错误
const handleError = (title, message) => {
    hasError.value = true
    errorTitle.value = title
    errorMessage.value = message
    loading.value = false
}

// 初始化微信授权
const initWechatAuth = () => {
    // 获取当前url中的code参数
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get('code')

    // 判断用户取消授权
    const error = urlParams.get('error')
    const errorDesc = urlParams.get('error_description')
    if (error) {
        console.log('用户取消授权:', errorDesc)
        handleError('获取用户信息失败', errorDesc)
        return
    }

    if (!code) {
        // 如果没有code，重定向到微信授权页面
        const redirectUri = encodeURIComponent(window.location.href)
        const appId = WECHAT_APPID
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
    } else {
        // 有code则获取用户信息
        getUserInfo({
            code: code,
            app_id: WECHAT_APPID,
            page_type: '首页'
        })
    }
}

// 获取用户信息
const getUserInfo = async (data) => {
    try {
        const res = await post('/api/index/info', data)

        if (res.result && res.result.state === 'ok') {
            const userInfo = res.result.partner_info || {}
            const accountInfo = res.result.account_info || {}

            // 存储用户ID到本地存储
            if (userInfo.id) {
                localStorage.setItem('userId', userInfo.id)
                if (accountInfo.company_ids) {
                    localStorage.setItem('company_ids', JSON.stringify(accountInfo.company_ids))
                }
                // 如果API返回了图片数据，则使用API数据，否则使用默认图片
                if (accountInfo.index_attachment_ids && accountInfo.index_attachment_ids.length > 0) {
                    images.value = accountInfo.index_attachment_ids
                }
                if (accountInfo.user_default_image) {
                    localStorage.setItem('user_default_image', accountInfo.user_default_image)
                }
            }
        } else {
            handleError('获取用户信息失败', res.result?.message || '获取用户信息失败')
        }
    } catch (error) {
        console.error('获取用户信息失败:', error)
        handleError('获取用户信息失败', '获取用户信息失败，请重试')
    } finally {
        loading.value = false
    }
}

// 页面初始化
const initPage = async () => {
    try {
        console.log('onMounted:首页')
        console.log('微信AppID:', WECHAT_APPID)
        setWxTitle('首页')

        // 检查是否已有用户ID
        if (localStorage.getItem('userId')) {
            getUserInfo({
                partner_id: localStorage.getItem('userId'),
                app_id: WECHAT_APPID,
                page_type: '首页'
            })
        } else {
            initWechatAuth()
        }

    } catch (error) {
        console.error('页面初始化失败:', error)
        loading.value = false
    }
}

onMounted(() => {
    initPage()
})

function goOrder() {
    window.location.href = '/order';
}


</script>

<style scoped>
.home {
    height: calc(100vh - 50px - env(safe-area-inset-bottom));
    background: #f7f8fa;
    overflow: auto;
}

.my-swipe {
    height: calc(100vh - 145px - env(safe-area-inset-bottom));
}

.banner-img {
    width: 100%;
    height: calc(100vh - 145px - env(safe-area-inset-bottom));
}

.order-btn-wrap {
    margin: 24px 16px;
}
</style>